import React, { Component } from 'react';
import Link from 'components/Link';
import HeaderSections from 'components/HeaderSections';
import WL from 'constants/whiteLabel';
import styles from './asicHeader.module.css';

class AsicHeader extends Component {
  render() {
    return (
      <header className={styles.header}>
        <div className={styles.sectionsContainer}>
          <HeaderSections isAsic />
        </div>
        <div className={styles.wrapper}>
          <div className={styles.root}>
            <div className={styles.rootBlock}>
              <Link withLang to="/asic" className={styles.logoHead}>
                <img
                  src={WL.getLogoAsic()}
                  width={WL.getLogoAsicWidth()}
                  height={WL.getLogoAsicHeight()}
                  alt="logo"
                  className={styles.img}
                />
              </Link>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default AsicHeader;
